import { uniqBy } from 'lodash';

export const initialState: MBGIFState = {
  trending: [],
  searchResults: {},
  searchQuery: null,
  isError: false,
};

export function gifsReducer(state: MBGIFState = initialState, action: GIFAction): MBGIFState {
  switch (action.type) {
    case 'GIFS:UPDATE_SEARCH_QUERY': {
      return {
        ...state,
        searchQuery: action.value.query,
      };
    }

    case 'GIFS:SET_TRENDING': {
      const { gifs } = action.value;
      return { ...state, trending: gifs };
    }

    case 'GIFS:APPEND_TRENDING': {
      const { gifs } = action.value;
      return {
        ...state,
        trending: uniqBy([...state.trending, ...gifs], 'id'),
      };
    }

    case 'GIFS:APPEND_SEARCH_RESULTS': {
      const { query, gifs } = action.value;
      const previousResults = state.searchResults[query] || [];

      return {
        ...state,
        searchResults: {
          ...state.searchResults,
          // For the search query, append all new results to the
          // old existing results. This makes handling pagination
          // and fetching unlimited GIFs really easy
          [query]: uniqBy([...previousResults, ...gifs], 'id'),
        },
      };
    }

    case 'GIFS:SET_IS_ERROR': {
      const { isError } = action.value;
      return { ...state, isError };
    }

    default:
      return state;
  }
}
